import React, { useContext, useRef, useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { AuthContext, GlobalContext } from '../../../services/context'
import { withRouter } from 'react-router-dom'
import leftArrow from '../../asset/icons/left_arrow.svg'
import useBreakpoint from '../../../dpe-usco/services/useBreakpoint'
import { Button } from 'syngenta-react-components'
import { getContractById, patchDeleteCompany, getHighestRole } from '../../../services/apiHelper'
import ModalWithStates from '../../../dpe-usco/components/ModalWithStates/ModalWithStates'

const DetailView = props => {
  const [breakpoint] = useBreakpoint()
  const viewIsMobile = breakpoint === 'mobile'
  const { state, dispatch } = useContext(GlobalContext)
  const backPath = props.match && props.match.path ? props.match.path.substring(0, props.match.path.lastIndexOf('/')) : ''
  const kids = React.Children.toArray(props.children)
  const voidedDate = useRef()

  const { hasAccess } = useContext(AuthContext)
  const { contract_id } = useParams() || {}
  const [showModal, setShowModal] = useState(false)
  const [userInfo, setUserInfo] = useState({})
  const { isVoided, modifiedDate } = props
  const [apiCalled, setApiCalled] = useState(false)

  if (isVoided && modifiedDate) {
    const d = new Date(modifiedDate)
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]
    const year = d.getFullYear()
    const month = monthNames[d.getMonth()]
    const date = d.getDate()
    const time = d.toLocaleTimeString({ hour12: true })
    const dateAndTime = month + ' ' + date + ', ' + year + ', ' + time
    voidedDate.current = dateAndTime
  }

  const goBack = e => {
    e.preventDefault()
    dispatch({ type: 'GO_BACK' })
  }

  const [title, setTitle] = useState('')
  const [newContractId, setNewContractId] = useState('')
  const [previous, setPrevious] = useState('')
  const [deleteAuth, setDeleteAuth] = useState(false)

  useEffect(() => {
    getHighestRole()?.then(res => {
      if (!res) return
      if (res.permissions && res.permissions.includes('delete-void')) {
        setDeleteAuth(true)
      } else {
        setDeleteAuth(false)
      }
      setUserInfo(
        {
          'user_id': res.user_id,
          'user_name': res.first + ' ' + res.last,
          'user_email': res.email,
          'system_name': 'GrowMore360'
        }
      )
    })
  }, [])


  useEffect(() => {
    let new_title = ''
    if (props.title)
      new_title = props.title
    else {
      if (state.detailView) {
        new_title = state.detailView.title
      }
    }
    if (!new_title) {
      new_title = ''
      if (state.lastDetailView)
        new_title = state.lastDetailView.title
    }

    let new_contract_id = ''
    if (props.new_contract_id) {
      new_contract_id = props.new_contract_id
    } else {
      if (state.detailView)
        new_contract_id = state.detailView.new_contract_id
    }

    if (!new_contract_id && new_title !== 'New contract') {
      if (state.lastDetailView) {
        new_contract_id = state.lastDetailView.new_contract_id
      } else {
        new_contract_id = ''
      }
    } else {
      new_contract_id = ''
    }

    let new_previous = ''
    if (props.previous) {
      new_previous = props.previous
    }
    else {
      if (state.detailView) {
        new_previous = state.detailView.previous
      }
    }

    setTitle(new_title)
    if (!new_contract_id && !apiCalled) {
      setNewContractId(new_contract_id)
    }
    setPrevious(new_previous)
    if (contract_id && !new_contract_id && new_title !== 'New contract' && !apiCalled) {
      setApiCalled(true)
      getContractById(contract_id)
        .then(response => {
          setNewContractId(response?.new_contract_id)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }, [contract_id, props, state, apiCalled])



  let titleRow = (
    <>
      <div className='fw600 fz28 df fs pb10 bb1-s-lightgray'>
        <div className='fw600 fz28 tal pb10'>
          <div>{title}</div>
          <div>{props.companyPage ? null : newContractId}</div>
        </div>
      </div>

    </>
  )

  const handleClose = () => {
    setShowModal(false)
  }

  const handleOpen = () => {
    setShowModal(true)
  }

  const deleteContract = () => {
    setShowModal(false)
    patchDeleteCompany(contract_id, userInfo)
  }

  const bottomRow = <Link
    to='/dashboard'
  >
    <Button
      styleType="success"
      onClick={deleteContract}
      customClassName="ml10 mr10"
    >
      OK
    </Button>
  </Link>

  if (props.button) {
    titleRow = (
      <div className='df jcsb bb1-s-lightgray'>
        <div className='fw600 fz28 tal pb10'>
          <div>{title}</div>
          <div>{props.companyPage ? null : newContractId}</div>
        </div>

        <div>
          <div className="df">
            <div>
              {props.button}
            </div>
            {isVoided && deleteAuth && hasAccess() === 'SUCCESS' ?
              <Button onClick={handleOpen} styleType="error" customClassName="mr10 ml10">
                Delete contract
              </Button> : null}
          </div>
          {isVoided ?
            <div className='mb5 fz15 tar c-darkgray'>
              Voided: {voidedDate.current}
            </div> : null}
        </div>
      </div>
    )
  }

  if (props.button && props.title) {
    titleRow = (
      <div className='df jcsb bb1-s-lightgray'>
        <div className='fw600 fz28 tal pb10'>
          {title}
        </div>
        <div>{props.companyPage ? null : newContractId}</div>
        {props.button}
      </div>
    )
  }

  const renderKids = (kids, viewIsMobile) => {
    let leftKids = (<>{kids[0]}</>)
    let rightKids = (<>{kids[1]}</>)
    if (kids.length === 1) {
      return (
        <div className='w100%'>
          {kids[0]}
        </div>
      )
    }
    else {
      return (
        <>
          <div className={`mr25 ${viewIsMobile ? 'w100%' : 'w66.6666%'}`}>
            {leftKids}
          </div>
          <div data-testid='detailViewRight' className={`${viewIsMobile ? 'w100%' : 'w33.3333%'}`}>
            {rightKids}
          </div>
        </>
      )
    }
  }

  const disableBackButton = props.disableBack ? props.disableBack : false
  return (
    <div className='pl25 pr25'>
      {
        state.detailView && state.detailView.previous && !disableBackButton ?
          <a href={backPath} className='tdn' onClick={goBack}>
            <div className='fz17 c-neutral-500 df fs mb16'>
              <img src={leftArrow} alt='return arrow' className='curp' />
              <div className='ml10 curp'>{previous}</div>
            </div>
          </a>
          :
          <div className='mb16 h22'></div>
      }
      {titleRow}
      <div className={`${viewIsMobile ? '' : 'df'}`}>
        {renderKids(kids, viewIsMobile)}
      </div>
      <ModalWithStates
        handleClose={handleClose}
        showModal={showModal}
        bottomRow={bottomRow}
        content={'Are you sure you want to permanently Delete this contract?'}
      />
    </div>
  )
}

export default withRouter(DetailView)